import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { provideHttpClient, HttpClient } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { provideIonicAngular, IonicRouteStrategy } from '@ionic/angular/standalone';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicStorageModule } from '@ionic/storage-angular';
import * as CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';
import { Drivers } from '@ionic/storage';
import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER } from "ngx-ui-loader";
import { routes } from './app.routes';

// NgxUiLoader configuration
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    fgsType: SPINNER.ballSpinClockwise,
    fgsColor: 'var(--ion-color-primary)',
    pbColor: 'var(--ion-color-primary)',
    overlayColor: 'rgba(255,255,255,.4)',
    delay: 0,
    // "logoPosition": "center-center",
    // "logoSize": 80,
    // "logoUrl": "assets/images/tab_1.svg",
};

// Translation loader factory
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// Translation configuration
const translateConfig = {
    //defaultLanguage: 'en',
    isolate: true,
    extend: true,
    loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
    }
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideHttpClient(),
        provideIonicAngular(),
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        importProvidersFrom([
            BrowserModule,
            TranslateModule.forRoot(translateConfig),
            NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
            IonicStorageModule.forRoot({
                driverOrder: [CordovaSQLiteDriver._driver, Drivers.IndexedDB]
            })
        ])
    ]
};